<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "nav navbar-nav", attrs: { id: "main-menu-navigation" } },
    _vm._l(_vm.items, function (item) {
      return _c(_vm.resolveNavComponent(item), {
        key: item.header || item.title,
        tag: "component",
        attrs: { item: item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import horizontal_nav_menu_header_link_HorizontalNavMenuHeaderLink_vue from '../horizontal-nav-menu-header-link/HorizontalNavMenuHeaderLink.vue';
import horizontal_nav_menu_header_group_HorizontalNavMenuHeaderGroup_vue from '../horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default ({
  render,
  staticRenderFns,
  components: {
    HorizontalNavMenuHeaderLink: horizontal_nav_menu_header_link_HorizontalNavMenuHeaderLink_vue,
    HorizontalNavMenuHeaderGroup: horizontal_nav_menu_header_group_HorizontalNavMenuHeaderGroup_vue
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  setup() {
    const resolveNavComponent = item => {
      if (item.children) return 'horizontal-nav-menu-header-group';
      return 'horizontal-nav-menu-header-link';
    };
    return {
      resolveNavComponent
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

